import { all, put, SagaGenerator, select, takeLatest } from "typed-redux-saga";
import { Action } from "typescript-fsa";

import { ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { Commands } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import { FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";

import { TASK_DETAIL_ACTIVITY_ID } from "../../../processOverview/store/actions";

import { editAntragAction } from "../actions";

export function* editAntragSaga(): SagaGenerator<void> {
	yield* takeLatest(editAntragAction.match, handle);
}

type EventAction = Action<FormEngineActions.FormEngineEventActions>;
function* handle(action: EventAction): SagaGenerator<void> {
	const { activityId } = action.payload;

	const processActivityData = yield* select(ActivitySelectors.data(TASK_DETAIL_ACTIVITY_ID));

	if (!processActivityData) {
		return;
	}

	yield* all([
		put(
			FormEngineActions.command({
				activityId,
				engineEvent: Commands.setReadonly(false)
			})
		),
		put(
			FormEngineActions.command({
				activityId: TASK_DETAIL_ACTIVITY_ID,
				engineEvent: Commands.setReadonly(true)
			})
		)
	]);
}
